














/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import Component from 'vue-class-component';
import LayerLegend from '@/components/plugins/legend/LayerLegend.vue';
import MapLegendCard from '@/components/plugins/legend/MapLegendCard.vue';
import PluginComponent from '@/components/plugins/PluginComponent';

@Component({
  props: {
  },
  components: {
    LayerLegend,
    MapLegendCard,
  },
})
export default class LegendPlugin extends PluginComponent {
  static ID = 'LegendPlugin';

  isOnMap: boolean = false;

  mounted() {
    console.log('LegendPlugin Mounted');
    this.isOnMap = this.plugin.getParameterValue('displayOnMap') === true;
  }
}
